import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { AddNode, ClearFilter, DeleteIcon, Edit, EditButtonIcon, FilterIcon, InfoIcon1, RemoveIcon, SaveFilter } from '../../../assets/images'
import { useDispatch, useSelector } from 'react-redux'
import { MaterialReactTable } from 'material-react-table'
import EditNoteIcon from '@mui/icons-material/EditNote';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Button, Tooltip, Box, CircularProgress, IconButton } from '@mui/material'
import { useHistory } from 'react-router-dom';
import { MultiSelect } from 'react-multi-select-component'
import InterfaceAdditionForm from './InterfaceAdditionForm'
import AlertTemplateMessage from '../../Configuration/AlertTemplate/AlertTemplateMessage'
import { Mention, MentionsInput } from 'react-mentions'
import Swal from 'sweetalert2'
import filtersConfig from '../Filters'
import { deleteInterfaceDetails, getAllFilters, getAllInterfaceList } from '../../../services/configurationServices'
import { SuccessToast } from '../../../CustomHooks/SuccessToast'
import InterfaceBulkEditForm from './InterfaceBulkEditForm'
import InterfaceDiscoverConfig from './InterfaceDiscoverConfig'
import { getDiscoverDeviceList } from '../../../services/onVifService'
import { ErrorToast } from '../../../CustomHooks/ErrorToast'
import { set } from 'react-hook-form'


const InterfaceConfig = ({showSuccessToast}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [showAddSite, setShowAddSite] = useState(false);
  const [showBulkEditModal, setShowBulkEditModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [showSavedFilterDeleteModal, setShowSavedFilterDeleteModal] = useState(false)
  const [openInfoFilter, setOpenInfoFilter] = useState(false)
  const [modalFilterName, setModalFilterName] = useState("")
  const [selected, setSelected] = useState([]);
  const [editCountryId, setEditCountryId] = useState(null);
  const [rowSelection, setRowSelection] = useState({});
  const wrapperRef = useRef(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [filterValues, setFilterValues] = useState({});
  const [filterData, setFilterData] = useState(null);
  const [interfaceData, setInterfaceData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [visiblePasswords, setVisiblePasswords] = useState({});
  const [selectedIds, setSelectedIds] = useState([]);
const [isDiscoverLoading, setIsDiscoverLoading] = useState(false);

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [globalFilter, setGlobalFilter] = useState('');
  const [showInterfaceDiscoverForm, setShowInterfaceDiscoverForm] = useState(false);
  const[discoverDeviceList,setDiscoverDeviceList]=useState([])

  // Enhanced configuration with extensible field mappings
  const getPageConfiguration = () => {
    const pageConfig = filtersConfig.find(config => config.pagename === 'InterfaceConfiguration');
    if (!pageConfig) {
      console.warn('InterfaceConfiguration not found in filters config');
      return { filters: {}, fieldMapping: {}, displayConfig: {} };
    }
    return pageConfig;
  };

  const pageConfig = getPageConfiguration();
  const pageFilters = pageConfig.filters;
  
  // Dynamic field mapping configuration - can be moved to external config
  const defaultFieldMapping = {
    'Customer': 'ClientName',     // Display field for Customer dropdown
    'State': 'statename', 
    'City': 'City',
    'Site': 'SiteName',           // Display field for Site dropdown
    'Zone': 'ZoneName',
    'Interface': 'InterfaceName',
    'Device': 'DeviceName'
  };

  // Field mapping for API parameter values (ID fields)
  const apiFieldMapping = {
    'Customer': 'ClientId',       // API parameter field for Customer
    'State': 'statemasterid', 
    'City': 'City',
    'Site': 'SiteID',             // API parameter field for Site
    'Zone': 'ZoneID',
    'Interface': 'InterfaceID',
    'Device': 'DeviceID'
  };

  // Use configured field mapping or fall back to default
  const fieldMapping = pageConfig.fieldMapping || defaultFieldMapping;

  // Get the actual field name from configuration (with fallback to default mapping)
  const getFieldName = (filterKey) => {
    const filterConfig = pageFilters[filterKey];
    if (filterConfig && filterConfig.fieldName) {
      return filterConfig.fieldName;
    }
    return fieldMapping[filterKey] || filterKey;
  };

  // Get placeholder text from configuration
  const getPlaceholderText = (filterKey, filterConfig) => {
    if (filterConfig.placeholder) {
      return filterConfig.placeholder;
    }
    return `Select ${filterConfig.label}${filterConfig.mandatory ? '*' : ''}`;
  };
  
  // Excel-like Filter Utility - filters options based on other active selections
  const getFilteredOptions = (filterKey, valueKey, labelKey) => {
    if (!filterData || !filterData.Data) {
        return [];
    }

    // Build a filter object with only selected values for each filter (excluding current filter)
    const activeSelections = {};
    Object.keys(pageFilters).forEach(key => {
        const selected = filterValues[key];
        if (
            key !== filterKey &&
            Array.isArray(selected) &&
            selected.length > 0
        ) {
            activeSelections[key] = selected.map(item => 
                typeof item === "object" ? item.value : item
            );
        }
    });

    // Filter data based on all other active selections
    const filtered = filterData.Data.filter(item => {
        return Object.entries(activeSelections).every(([key, selectedVals]) => {
            const apiFieldName = apiFieldMapping[key] || defaultFieldMapping[key] || key;
            return selectedVals.includes(item[apiFieldName]);
        });
    });

    // Get unique options for this filter
    const seen = new Set();
    return filtered
        .filter(item => {
            const val = item[valueKey];
            if (!val || seen.has(val)) return false;
            seen.add(val);
            return true;
        })
        .map(item => ({
            label: item[labelKey],
            value: item[valueKey],
        }))
        .sort((a, b) => {
            // Sort options in ascending order by label
            return a.label.localeCompare(b.label, undefined, { 
                numeric: true, 
                sensitivity: 'base' 
            });
        });
  };


  // Create options from API filterData with Excel-like filtering - now fully dynamic
  const getFilterOptions = (filterKey) => {
    if (!filterData || !filterData.Data) {
        return [];
    }
    
    const displayFieldName = getFieldName(filterKey);           // Field for label (e.g., ClientName)
    const valueFieldName = apiFieldMapping[filterKey] || displayFieldName;  // Field for value (e.g., ClientId)
    
    return getFilteredOptions(filterKey, valueFieldName, displayFieldName);
  };

  const handleFilterChange = (filterKey, value) => {
    if(filterKey == 'Customer' && value.length > 0) {
      setSelectedCustomer(value[0])
    }
    setFilterValues(prev => {
        const newValues = {
            ...prev,
            [filterKey]: value
        };

        // Smart dependency clearing - clear dependent filters when parent changes
        const filterConfig = pageFilters[filterKey];
        if (filterConfig) {
            // Find and clear all dependent filters
            Object.entries(pageFilters).forEach(([key, config]) => {
                if (config.parentFilter === filterKey) {
                    newValues[key] = [];
                    // Recursively clear dependencies
                    const clearDependencies = (parentKey) => {
                        Object.entries(pageFilters).forEach(([depKey, depConfig]) => {
                            if (depConfig.parentFilter === parentKey) {
                                newValues[depKey] = [];
                                clearDependencies(depKey);
                            }
                        });
                    };
                    clearDependencies(key);
                }
            });
        }

        return newValues;
    });

    // Only reset table state when mandatory filters are changed
    const filterConfig = pageFilters[filterKey];
    if (filterConfig && filterConfig.mandatory) {
        // Reset table state when mandatory filters change
        setInterfaceData([]);
        setFiltersApplied(false);
        setRowSelection({});
        // Reset password visibility state when mandatory filters change
        setVisiblePasswords({});
        setPagination({
            pageIndex: 0,
            pageSize: 10,
        });
    }
  };

  // Enhanced validation with better error messaging
  const isMandatoryFiltersMissing = () => {
    return Object.entries(pageFilters).some(([filterKey, filterConfig]) => {
        return filterConfig.mandatory && (!filterValues[filterKey] || filterValues[filterKey].length === 0);
    });
  };

  // Get missing mandatory filters for better user feedback
  const getMissingMandatoryFilters = () => {
    return Object.entries(pageFilters)
        .filter(([filterKey, filterConfig]) => {
            return filterConfig.mandatory && (!filterValues[filterKey] || filterValues[filterKey].length === 0);
        })
        .map(([filterKey, filterConfig]) => filterConfig.label);
  };

  // Enhanced filter button tooltip
  const getFilterButtonTooltip = () => {
    const missingFilters = getMissingMandatoryFilters();
    if (missingFilters.length > 0) {
        return `Please select: ${missingFilters.join(', ')}`;
    }
    return "Apply Filter";
  };

  // Clear all filters function
  const handleClearAllFilters = () => {
    setFilterValues({});
    setInterfaceData([]);
    setFiltersApplied(false);
    setRowSelection({});
    // Reset password visibility state when clearing filters
    setVisiblePasswords({});
    setGlobalFilter('');
    setPagination({
        pageIndex: 0,
        pageSize: 10,
    });
  };

  // Handle global filter change with pagination reset
  const handleGlobalFilterChange = (value) => {
    setGlobalFilter(value);
    // Reset to first page whenever search changes
    setPagination(prev => ({
      ...prev,
      pageIndex: 0
    }));
  };

  // Apply filters function - now calls API and stores response
  const handleApplyFilters = async () => {
    if (!isMandatoryFiltersMissing()) {
        setLoading(true);
        setFiltersApplied(true);
        try {
            // Build API parameters from filter values
            const apiParams = {};
            
            // Map filter values to API parameters with correct field mappings
            Object.entries(filterValues).forEach(([filterKey, values]) => {
                if (Array.isArray(values) && values.length > 0) {
                    const value = values[0].value;
                    if (filterKey === 'Customer') {
                        apiParams.ClientID = value;  // Use ClientId from the value, not ClientName
                    } else if (filterKey === 'Site') {
                        apiParams.SiteID = value;
                    } else if (filterKey === 'State') {
                        apiParams.statemasterid = value;
                    } else if (filterKey === 'City') {
                        apiParams.City = value;
                    }
                }
            });

            const response = await getAllInterfaceList(apiParams);
            
            if (response && response.Status === 'success' && response.Data) {
                setInterfaceData(response.Data);
                // Reset password visibility state when new data is loaded
                setVisiblePasswords({});
            } else {
                setInterfaceData([]);
                setVisiblePasswords({});
                console.warn('No interface data received:', response);
            }
        } catch (error) {
            console.error('Error loading interface data:', error);
            setInterfaceData([]);
        } finally {
            setLoading(false);
        }
    }
  };

  // Toggle password visibility for a specific row
  const togglePasswordVisibility = (interfaceId) => {
    setVisiblePasswords(prev => {
      const newState = {
        ...prev,
        [interfaceId]: !prev[interfaceId]
      };
      return newState;
    });
  };

  // Password cell component
  const PasswordCell = ({ row, fieldName = 'Password' }) => {
    const interfaceId = row.original.InterfaceId || row.original.interfaceId;
    const visibilityKey = `${interfaceId}_${fieldName}`;
    const password = row.original[fieldName] || '';
    const isVisible = visiblePasswords[visibilityKey] || false;

    const handleToggle = (e) => {
      e.stopPropagation();
      togglePasswordVisibility(visibilityKey);
    };

    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span style={{ fontFamily: 'monospace', minWidth: '80px' }}>
          {isVisible ? password : '•'.repeat(Math.max(password.length, 8))}
        </span>
        <IconButton
          size="small"
          onClick={handleToggle}
          sx={{ padding: '2px' }}
          title={isVisible ? 'Hide password' : 'Show password'}
        >
          {isVisible ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
        </IconButton>
      </div>
    );
  };

  // Hooter status cell component
  const HooterCell = ({ row }) => {
    const isEnabled = row.original.isHooterEnabled;
    
    // Handle null/undefined values
    if (isEnabled === null || isEnabled === undefined) {
      return (
        <span style={{ 
          // color: '#9e9e9e',
          // fontStyle: 'italic'
        }}>
          Not Applicable
        </span>
      );
    }
    
    return (
      <span style={{ 
        // color: isEnabled ? '#4caf50' : '#f44336',
        // fontWeight: 'bold'
      }}>
        {isEnabled ? 'Enabled' : 'Disabled'}
      </span>
    );
  };

  const getStatus = (value) => {
    if(value === undefined || value === null) {
      return 'Not Applicable';
    }
    if (value === true || value === 'true') {
      return 'Enabled';
    }
    if (value === false || value === 'false') {
      return 'Disabled';
    }
    return value;
  };

  const columns = useMemo(() => {
    // Dynamic columns based on API response
    const dynamicColumns = [];

    const checkAvailability = (value) => {
      return value ? value : 'Not Applicable';
    };

    if (interfaceData.length > 0) {
      const sampleData = interfaceData[0];
      
      // Define column mappings for better display names and formatting
      // The order of this object determines the column order in the table
      const columnMappings = {
        'InterfaceName': { header: 'Interface Name', size: 300 },
        'Interfacetypename': { header: 'System', size: 180 },
        'Interfacesubtypename': { header: 'Brand', size: 200 },
        'EntityType': { header: 'Interface', size: 180 },
        'InterfaceIP': { header: 'Interface IP', size: 220 },
        'InterfacePort': { header: 'Interface Port', size: 220 },
        'Communicationport': { header: 'Communication Port', size: 280, Cell: ({ row }) => getStatus(row.original.Communicationport)   },
        'InternetProtocolPort': { header: 'HTTP Port', size: 200, Cell: ({ row }) => getStatus(row.original.InternetProtocolPort) },
        'UserName': { header: 'Interface Username', size: 280 },
        'Password': { header: 'Interface Password', size: 260,  
          muiTableBodyCellProps: {
            className: 'PasswordCell',
          },
        },
        'onvifusername': { header: 'Onvif Username', size: 280 },
        'onvifuserpassword': { header: 'Onvif Password', size: 260,  
          muiTableBodyCellProps: {
            className: 'PasswordCell',
          },
        },
        'isTwoWayEnabled': { header: 'Two Way Communication', size: 320, Cell: ({ row }) => getStatus(row.original.isTwoWayEnabled) },
        'isHooterEnabled': { header: 'Hooter', size: 180, Cell: ({ row }) => getStatus(row.original.isHooterEnabled) },
        'CheckInternalHooter': { header: 'Internal Hooter', size: 240, Cell: ({ row }) => getStatus(row.original.CheckInternalHooter) },
        'CheckExternalHooter': { header: 'External Hooter', size: 240, Cell: ({ row }) => getStatus(row.original.CheckExternalHooter) },
        'Abbreviation': { header: 'Timezone', size: 180 },
        'SerialNo': { header: 'Serial Number', size: 280 },
        'isonvif': { header: 'Onboarded via Onvif', size: 220, Cell: ({ row }) => row.original.isonvif ? 'Yes' : 'No' },
        
      };

      // Skip certain fields that shouldn't be displayed as columns
      const skipFields = ['InterfaceId', 'CheckPlaybackLongTime',
        'CheckPlaybackUTCTime', 'DeleteDateTime', 'DeleteFlag', 'LiveRTSPURL', 'InterfacesubtypeId', 'InterfacetypeId',
        'OrganizationMasterID', 'SiteId', 'PlaybackRTSPURL', 'UpdatedateTime', 'EntityTypeID','TimeZoneID'
      ];

      // Create columns in the order defined by columnMappings
      Object.keys(columnMappings).forEach(key => {
        // Only add column if the field exists in the data and is not in skip list
        if (sampleData.hasOwnProperty(key) && !skipFields.includes(key)) {
          const mapping = columnMappings[key];
          const column = {
            accessorKey: key,
            header: mapping.header,
            size: mapping.size,
            filterVariant: 'text',
          };

          // Use Cell component from columnMappings if provided
          if (mapping.Cell) {
            column.Cell = mapping.Cell;
          }

          // Special handling for Password column
          if (key === 'Password') {
            column.Cell = (props) => <PasswordCell {...props} fieldName="Password" />;
            column.enableSorting = false;
          }

          // Special handling for ONVIF Password column
          if (key === 'onvifuserpassword') {
            column.Cell = (props) => <PasswordCell {...props} fieldName="onvifuserpassword" />;
            column.enableSorting = false;
          }
          
          // Special handling for Hooter column
          if (key === 'isHooterEnabled') {
            column.Cell = HooterCell;
          }

          if (mapping.muiTableBodyCellProps) {
            column.muiTableBodyCellProps = mapping.muiTableBodyCellProps;
          }

          dynamicColumns.push(column);
        }
      });

      // Add any remaining fields from sampleData that aren't in columnMappings (fallback)
      Object.keys(sampleData).forEach(key => {
        if (skipFields.includes(key) || columnMappings[key]) return;

        const column = {
          accessorKey: key,
          header: key.replace(/([A-Z])/g, ' $1').trim(),
          size: 150,
          filterVariant: 'text',
        };

        dynamicColumns.push(column);
      });
    }

    // Always add actions column at the end
    dynamicColumns.push({
      accessorKey: "actions",
      header: "Actions",
      enableColumnActions: false,
      enableSorting: false,
      enableColumnOrdering: false,
      Cell: ({ row }) => (
        <div className="ActionBtns">
          <Tooltip title="Edit" placement="bottom">
            <button 
              className="DataAccessEdit borderButton" 
              onClick={() => showInterfaceForm(row?.original)}
              disabled={row?.original?.isonvif}> {/*Disable edit button for ONVIF onboarded interfaces */}
              <EditNoteIcon className="ActionsIcon" />
            </button>
          </Tooltip>

          <Tooltip title="Delete" placement="bottom">
            <button className="DataAccessEdit borderButton" onClick={e => onDeleteChange(e, row.original)}>
              <DeleteForeverIcon className="ActionsIcon" />
            </button>
          </Tooltip>
        </div>
      ),
      muiTableHeadCellProps: {
        sx: {
          position: "sticky",
          right: 0,
          backgroundColor: "#064dc3",
          borderTopRightRadius: "20px",
          color: "white",
          fontWeight: "bold",
          zIndex: 3,
          textAlign: "center",
        },
      },
      muiTableBodyCellProps: {
        sx: {
          position: "sticky",
          right: 0,
          zIndex: 2,
          textAlign: "center",
        },
      },
    });

    return dynamicColumns;
  }, [interfaceData, visiblePasswords]);


  const pagedData = useMemo(() => {
    let filteredData = interfaceData;
    
    // Apply global filter to complete dataset first
    if (globalFilter) {
      filteredData = interfaceData.filter(item => 
        Object.values(item).some(value => 
          String(value).toLowerCase().includes(String(globalFilter).toLowerCase())
        )
      );
    }
    
    // Then apply pagination to filtered data
    const start = pagination.pageIndex * pagination.pageSize;
    const end = start + pagination.pageSize;
    return filteredData.slice(start, end);
  }, [interfaceData, pagination, globalFilter]);

  // Get filtered count for pagination
  const filteredCount = useMemo(() => {
    if (!globalFilter) return interfaceData.length;
    
    return interfaceData.filter(item => 
      Object.values(item).some(value => 
        String(value).toLowerCase().includes(String(globalFilter).toLowerCase())
      )
    ).length;
  }, [interfaceData, globalFilter]);

  useEffect(() => {
    // const fetchFilters = async () => {
    //   try {
    //     const response = await getAllFilters({ Entity: 'Interface' });
    //     setFilterData(response);
    //     console.log('Interface filter data loaded:', response);
    //   } catch (error) {
    //     console.error('Error loading interface filters:', error);
    //     setFilterData(null);
    //   }
    // };
    
    fetchFilters();
  }, []);

  // Reset row selection when form is closed
  useEffect(() => {
    if (!showAddSite) {
      setRowSelection({});
      setSelectedRow(null);
    }
  }, [showAddSite]);

  const fetchFilters = async () => {
    try {
      const response = await getAllFilters({ Entity: 'Interface' });
      setFilterData(response);

    } catch (error) {
      console.error('Error loading interface filters:', error);
      setFilterData(null);
    }
  };

  const showSiteForm = () => {
    setShowAddSite(true);
    // Reset row selection when opening form to avoid confusion
    setRowSelection({});
  }

  const showInterfaceForm = (data) => {
    // history.push('/configuration/addinterface');
    setShowAddSite(true);
    if(data){
      setSelectedRow(data);
    }
    // Reset row selection when opening form to avoid confusion
    setRowSelection({});
  }

  // Get selected interface IDs from row selection
  const getSelectedInterfaceIds = () => {
    const selectedInterfaceIds = Object.keys(rowSelection).filter(key => rowSelection[key]);
    return selectedInterfaceIds;
  };

  const onBulkEditInterfaces = () => {
    const selectedIds = getSelectedInterfaceIds();
    if (selectedIds.length === 0) {
      alert('Please select at least one interface to edit.');
      return;
    }
    setSelectedIds(selectedIds)
    setShowBulkEditModal(true);
  };

  const onBulkDeleteInterface = (e) => {
    e.stopPropagation()
    const selectedIds = getSelectedInterfaceIds();
    if (selectedIds.length === 0) {
      alert('Please select at least one interface to delete.');
      return;
    }
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete the selected interfaces?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#027aaa",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Delete!"
    }).then((result) => {
      if (result.isConfirmed) {
        // Implement bulk delete logic here
        handleApplyFilters(); // Refresh data after deletion
      }
    })
  }

  const onDeleteChange = (e, row) => {
    e.stopPropagation();
    Swal.fire({
      title: "Are you sure?",
      text: `You really want to delete "${row.interfaceName || row.InterfaceName}" interface!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteInterface(row.InterfaceId);
      }
    });
  }

  function onDeleteInterface(e, interfaceId, name) {
    e.stopPropagation();
    Swal.fire({
      title: "Are you sure?",
      text: `Deleting the Interface will delete all the entites associated with it. Do you really want to delete ${name} interface!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteInterface(interfaceId)
      }
    });
  }

  const deleteInterface = async (interfaceId) => {
    let userId = localStorage.getItem("UserID");
    await deleteInterfaceDetails(userId, interfaceId)
      .then((resp) => {
        if (resp.Status == "success") {
          SuccessToast(resp.Message);
          handleApplyFilters();
          fetchFilters();
          return;
        } else if (resp.Status === "failed") {
          Swal.fire({ text: resp.Message });
        } else {
          Swal.fire({ text: "Something went wrong, please try again later!" });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (wrapperRef.current) {
      const labelEl = wrapperRef.current.querySelector(
        ".dropdown-heading .dropdown-heading-value"
      );
      if (labelEl) {
        const firstFilterKey = Object.keys(pageFilters)[0];
        const firstSelection = filterValues[firstFilterKey];
        const selectedLabel = firstSelection?.[0]?.label || "";
        const isTruncated = labelEl.scrollWidth > labelEl.clientWidth;
        labelEl.setAttribute("title", isTruncated ? selectedLabel : "");
      }
    }
  }, [filterValues]);


  // Generate filter summary for display
  const getFilterSummary = () => {
    const activeFilters = Object.entries(filterValues)
      .filter(([key, value]) => Array.isArray(value) && value.length > 0)
      .map(([key, value]) => {
        const config = pageFilters[key];
        const label = config ? config.label : key;
        const selectedLabel = value[0]?.label || value[0];
        return `${label}: ${selectedLabel}`;
      });
    
    return activeFilters.length > 0 ? activeFilters.join(' | ') : 'No filters applied';
  };

   

  return (
    <>
   
    <div className='p-3'>
      {
        showInterfaceDiscoverForm ? (
          <InterfaceDiscoverConfig
          setShowInterfaceDiscoverForm={setShowInterfaceDiscoverForm}
          />
        ) : (
 
      <div>
        {showAddSite ? (
          <InterfaceAdditionForm
            showAddSite={showAddSite}
            setShowAddSite={setShowAddSite}
            selectedRow={selectedRow}
            selectedCustomer={selectedCustomer}
            handleApplyFilters={handleApplyFilters}
            fetchFilters={fetchFilters}
            filterValues={filterValues}
          />
        ) : (
          <div className="SiteMainContainer SiteTableMainDiv">
            <div className="DashboardFilterMainDiv">
              <div className="RefreshText" style={{ display: "flex" }}>
                {Object.entries(pageFilters)
                  .sort(([, a], [, b]) => a.sequence - b.sequence)
                  .map(([filterKey, filterConfig]) => (
                    <div key={filterKey} className="inputTypeLabelContainer">
                      <label className="formFieldLabels">
                        {filterConfig.label}
                        {filterConfig.mandatory && <span style={{ color: 'red' }}>*</span>}
                      </label>
                      <div ref={wrapperRef}>
                        <MultiSelect
                          key={filterValues[filterKey]?.[0]?.value}
                          options={getFilterOptions(filterKey)}
                          value={filterValues[filterKey] || []}
                          onChange={(value) => handleFilterChange(filterKey, value.length > 1 ? [value[value.length - 1]] : value)}
                          labelledBy={`Select ${filterConfig.label}`}
                          hasSelectAll={false}
                          isCreatable={false}
                          disableSearch={false}
                          className="SiteConfigSingleSelectDropdownContainer"
                          overrideStrings={{
                            selectSomeItems:
                            (filterValues[filterKey] && filterValues[filterKey][0] && filterValues[filterKey][0].label)
                                ? filterValues[filterKey][0].label
                                : getPlaceholderText(filterKey, filterConfig),
                            allItemsAreSelected:
                            (filterValues[filterKey] && filterValues[filterKey][0] && filterValues[filterKey][0].label)
                                ? filterValues[filterKey][0].label
                                : getPlaceholderText(filterKey, filterConfig),
                          }}
                        />
                      </div>
                    </div>
                  ))}
                <div className="HMFilterDiv">
                  <Tooltip title={getFilterButtonTooltip()} placement="bottom">
                    <button
                      className="IconsButtonDiv"
                      name="filterBtn"
                      disabled={isMandatoryFiltersMissing() || loading}
                      style={{
                        opacity: (isMandatoryFiltersMissing() || loading) ? 0.5 : 1,
                        cursor: (isMandatoryFiltersMissing() || loading) ? 'not-allowed' : 'pointer'
                      }}
                      onClick={handleApplyFilters}
                    >
                      <img
                        src={FilterIcon}
                        className="camera-icon-height"
                        alt="Apply filter icon"
                      />
                    </button>
                  </Tooltip>
                  <Tooltip title="Clear Filter" placement="bottom">
                    <button
                      className="IconsButtonDiv"
                      name="clearFilterBtn"
                      disabled={loading}
                      style={{
                        opacity: loading ? 0.5 : 1,
                        cursor: loading ? 'not-allowed' : 'pointer'
                      }}
                      onClick={handleClearAllFilters}
                    >
                      <img
                        src={ClearFilter}
                        className="camera-icon-height"
                        alt="Clear filter icon"
                      />
                    </button>
                  </Tooltip>
                </div>
              </div>
            </div>
            <div className="SiteMainHeightDiv">
              <div className="col-lg-12 m-0 TabulerReportMainDiv MatReactTableDiv" style={{ height: "calc(100vh - 290px)" }}>
                <div className="card-body p-0">
                  {loading ? (
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      minHeight="400px"
                      flexDirection="column"
                    >
                      <CircularProgress size={60} thickness={4} />
                      <Box mt={2}>
                        <span style={{ fontSize: '16px', color: '#666' }}>
                          {isDiscoverLoading ? 'Loading discover devices data...' : 'Loading interface data...'}
                        </span>
                      </Box>
                    </Box>
                  ) : interfaceData.length === 0 ? (
                    <div style={{ width: "100%", padding: "20px", textAlign: "center" }}>
                      <AlertTemplateMessage
                        message={
                          !filtersApplied || isMandatoryFiltersMissing()
                            ? "Please select mandatory filters and click Apply Filter to load interface data."
                            : "No interfaces found for the selected filters."
                        }
                      />
                    </div>
                  ) : (
                    <MaterialReactTable
                      columns={columns}
                      data={pagedData}
                      enableGlobalFilter={true}
                      enableColumnFilters={false}
                      enableStickyHeader
                      enableColumnResizing={true}
                      globalFilterFn="contains"
                      columnResizeMode="onEnd"
                      enableColumnOrdering={true}
                      enableRowSelection={true}
                      muiTableHeadCellProps={{
                        className: "myHeaderSelectAll",
                      }}
                      enableHiding={true}
                      displayColumnDefOptions={{
                        'mrt-row-select': {
                          visibleInShowHideMenu: false,
                          muiTableHeadCellProps: {
                            sx: {
                              position: "sticky",
                              left: 0,
                              backgroundColor: "#0b70d1",
                              borderTopLeftRadius: "20px",
                              color: "white",
                              fontWeight: "bold",
                              zIndex: 5,
                            },
                          },
                          muiTableBodyCellProps: {
                            sx: {
                              position: "sticky",
                              left: 0,
                              backgroundColor: "inherit",
                              zIndex: 4,
                            },
                          },
                        },
                      }}
                      initialState={{ showColumnFilters: false }}
                      manualPagination={true}
                      manualFiltering={true}
                      rowCount={filteredCount}
                      getRowId={(row) => row.InterfaceId}
                      state={{
                        pagination: pagination,
                        rowSelection: rowSelection,
                        globalFilter: globalFilter,
                      }}
                      onRowSelectionChange={setRowSelection}
                      onPaginationChange={setPagination}
                      onGlobalFilterChange={handleGlobalFilterChange}
                      muiTableContainerProps={{
                        className: "MaterialTableJs myTableContainer",
                        sx: {
                          maxHeight: "100%",
                          overflowX: "auto",
                        },
                      }}
                      muiTableHeadProps={{
                        className: "myHeader",
                        sx: {
                          display: "table-header-group",
                        },
                      }}
                      renderTopToolbarCustomActions={({ table }) => (
                        <div className='d-flex justify-content-center align-items-center'>
                          <h4 style={{ margin: 0 }}>
                            List of interfaces {interfaceData.length > 0 && `(${interfaceData.length} records)`}
                          </h4>
                        </div>
                      )}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className='mb-2 mt-2'>
              <Button
                className='m-1 ConfigBelowButtons'
                variant="contained"
                onClick={() => showInterfaceForm(null)}
                disabled={!filtersApplied}
                style={{
                  cursor: (!filtersApplied) ? 'not-allowed' : 'pointer',
                }}
              >
                Add Interface
              </Button>
              <Button
                className='m-1 ConfigBelowButtons'
                variant="contained"
                onClick={onBulkEditInterfaces}
                disabled={Object.keys(rowSelection).filter(key => rowSelection[key]).length === 0}
              >
                Bulk Edit {Object.keys(rowSelection).filter(key => rowSelection[key]).length > 0 && `(${Object.keys(rowSelection).filter(key => rowSelection[key]).length})`}
              </Button>
               {/* <Button
                className='m-1 ConfigBelowButtons'
                variant="contained"
                onClick={()=>setShowInterfaceDiscoverForm(true)}
                // disabled={!filtersApplied || isDiscoverLoading}
                // style={{
                //   cursor: (!filtersApplied || isDiscoverLoading) ? 'not-allowed' : 'pointer',
                // }}
                
                >
                 {'Discover Devices'}
              </Button> */}
              {/* <Button className='m-1' variant="contained" onClick={onBulkDeleteInterface}>Bulk Delete</Button> */}
            </div>
          </div>
        )}
      </div>
     
        )}
    </div>
 
      {/* Bulk Edit Modal */}
      <Modal
        show={showBulkEditModal}
        onHide={() => setShowBulkEditModal(false)}
        dialogClassName="widgetModelDiv"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <>
          <Modal.Header>
            <Modal.Title id="example-custom-modal-styling-title">
              Interface Bulk Edit
            </Modal.Title>
            <img
              src={RemoveIcon}
              alt="Remove"
              style={{ cursor: "pointer" }}
              onClick={() => { setShowBulkEditModal(false) }}
            />
          </Modal.Header>
 
          <Modal.Body>
            {/* <div className='SiteFormAdditionForm border-top-0'>
              <form style={{ width: "100%" }}>
                <div className="site-form">
                  <div className="inputMainContainer w40dot75rem">
                    <div className="inputTypeLabelContainer">
                      <label className='formFieldLabels'>Interface Port</label>
                      <input className="inputType"
                        placeholder="Enter Interface Port*" />
                      <p className="Error_P" style={{ float: "left" }}><span> { } </span></p>
                    </div>
                  </div>
                  <div className="inputMainContainer w40dot75rem mt35">
                    <div className="inputTypeLabelContainer">
                      <label className='formFieldLabels'>Communication Port</label>
                      <input className="inputType"
                        placeholder="Enter Communication Port* e.g. 8080" />
                      <p className="Error_P" style={{ float: "left" }}><span> { } </span></p>
                    </div>
                  </div>
                  <div className="inputMainContainer w40dot75rem mt35">
                    <div className="inputTypeLabelContainer">
                      <label className='formFieldLabels'>HTTP Port</label>
                      <input
                        className="inputType"
                        placeholder="Enter HTTP Port* e.g. 443" />
                      <p className="Error_P" style={{ float: "left" }}><span> { } </span></p>
                    </div>
                  </div>
                  <div className="inputMainContainer w40dot75rem mt35">
                    <div className="inputTypeLabelContainer">
                      <label className='formFieldLabels'>Interface Username</label>
                      <input className="inputType"
                        placeholder="Enter Interface Username*"
                      />
                      <p className="Error_P" style={{ float: "left" }}><span> { } </span></p>
                    </div>
                  </div>
 
                  <div className="inputMainContainer w40dot75rem mt35">
                    <div className="inputTypeLabelContainer">
                      <label className='formFieldLabels'>Interface Password</label>
                      <input
                        className="inputType"
                        placeholder="Enter Interface Password*"
                      />
                      <p className="Error_P" style={{ float: "left" }}><span> { } </span></p>
                    </div>
                  </div>
 
                  <div className="inputMainContainer w40dot75rem mt35">
                    <div className="inputTypeLabelContainer">
                      <label className='formFieldLabels'>Timezone</label>
                      <select
                        className="inputType ArrowSelectClass" >
                        <option key="0" disabled={false} value="0" id="0">Select timezone*</option>
                        <option>UTC</option>
                        <option>IST</option>
                        <option>EST</option>
                      </select>
                      <p className="Error_P" style={{ float: "left" }}><span> { } </span></p>
                    </div>
                  </div>
 
                  <div className="inputMainContainer w40dot75rem mt35">
                    <div className="inputTypeLabelContainer">
                      <label className='formFieldLabels'>Two Way Communication</label>
                      <div
                        className="onlyforEnableCheckbox"
                      >
                        <input
                          className="checkbox_custom"
                          type="checkbox" />
                        <label className="mb-0" >
                          Two Way Communication Available
                        </label>
                      </div>
                    </div>
                  </div>
 
                  <div className="inputMainContainer w40dot75rem mt35">
                    <div className="inputTypeLabelContainer">
                      <label className='formFieldLabels'>Enable Hooter Types</label>
                      <div className='mt-1 signTypeCheckboxLabels'>
                        <div className="SiteTextBox SiteNameText mt-0">
                          <div className="onlyforEnableCheckbox ml-0">
                            <input className="checkbox_custom" type="checkbox" />
                            <label className="mb-0">
                              Enable Internal Hooter
                            </label>
                          </div>
                        </div>
                        <div className="SiteTextBox SiteNameText mt-0">
                          <div className="onlyforEnableCheckbox ml-0">
                            <input className="checkbox_custom"
                              type="checkbox" />
                            <label className="mb-0">
                              Enable External Hooter
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
 
                  <div className="inputMainContainer w40dot75rem mt35">
                    <div className="inputTypeLabelContainer">
                      <label className='formFieldLabels'>Enable/Disable Hooter</label>
                      <div className="onlyforEnableCheckbox">
                        <input
                          className="checkbox_custom"
                          type="checkbox" />
                        <label className="mb-0">
                          Enable Hooter
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div style={{ textAlign: "center" }}>
              <button
                className="DataAccessEdit mt-3"
                style={{ width: "100px" }}>
                <span className="ViewUpdate">Submit</span>
              </button>
              <button onClick={() => setShowBulkEditModal(false)}
                className="DataAccessEdit mt-3"
                style={{ width: "100px" }}>
                <span className="ViewUpdate">Cancel</span>
              </button>
            </div> */}
            <InterfaceBulkEditForm setShowBulkEditModal={setShowBulkEditModal} selectedIds={selectedIds} handleApplyFilters={handleApplyFilters} filterValues={filterValues} />
          </Modal.Body>
        </>
      </Modal>
    </>
  )
}

export default InterfaceConfig